(process.env as any) = import.meta.env;
(window as any).__NZ_APP__ = 'platform';
